<div style="height:calc(100vh - 64px); overflow-y: auto; padding: 25px;">
  <div class="fluid-container container-fluid p4">
    <div class="row justify-content-start">
      <div class="col-6 col-md-5">
        <div style="display: flex;">
          <mat-icon color="primary" class="rm-header-icon">dashboard</mat-icon>&nbsp;
          <span class="rm-title rm-title-3">Rondeivu's Dashboard</span>
        </div>
      </div>
      <div class="col-12 col-md-11">
        <span class="rm-title rm-title-6">
            The Operating System for Private Markets
        </span>
      </div>
    </div>


    <mat-expansion-panel #userActivityPanel [expanded]="true" *ngIf="userActivity.length > 0" class="mt-4 mb-4 mat-elevation-z0">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h1>Recent User Activity</h1>
        </mat-panel-title>
        <!-- <mat-panel-description *ngIf="!userActivityPanel.expanded">
          View recent user activity, including logins, deal views, and other interactions with the platform. Click to expand and see details.
        </mat-panel-description> -->
      </mat-expansion-panel-header>
      <!-- User Activity -->
      <div class="user-activity-container">
        <div *ngFor="let activity of userActivity" class="user-activity-item">
          <span>{{activity.created | date:'short'}}</span>
          <span>{{activity.message}}</span>
        </div>
      </div>

    </mat-expansion-panel>

    <!-- Blurb for DEMO users -->
    <div class="row" [hidden]="environment.rondeivu_env_title !== 'DEMO'">
      <div class="demo-desc-section col-12 pt-4 mb-4">
        <h1>What Is Rondeivu</h1>
        <p>
          <b>Rondeivu is the first full-lifecycle vertical ERP purpose-built for institutional private markets.</b> <br />
          Source, diligence, transact, and monitor in one seamless system spanning front, middle, and back office. Built on 50+ years of buy-side experience at leading institutional investors.
        </p>

        <h1>The Demo Portal</h1>
        <p>
          In production, this dashboard is dedicated to client reporting and value-added insights.<br />
          In the demo environment, it guides you through the features and workflows that power Rondeivu's private markets operating system, with prompted onboarding to help you explore the platform.
        </p>
      </div>
      <br />
      <div class="demo-feature-section">
        <div class="demo-feature-col mat-elevation-z8">
          <h2>Onboarding & Identity</h2>
          <ul>
            <li><b>Rapid Setup:</b> Fully onboarded in under 10 minutes. And matched to your first deal</li>
            <li><b>Verified Security:</b> Bank-level security with a controlled environment to mitigate risk</li>
            <li><b>Rinse-&-Repeat KYC:</b> Complete KYC once to automate all future deal subscriptions</li>
          </ul>

          <br />
          <h2>Intelligence & Sourcing</h2>
          <ul>
            <li><b>Precision Matching:</b> Receive only the deals that fit your specific mandate</li>
            <li><b>AI Business Development:</b> Multi-tool coordination of public and private data to identify high-value prospects</li>
            <li><b>Relative Attractiveness:</b> Standardized metrics (liquidity, cash flow, correlation) to help CIOs compare opportunities easily</li>
            <li><b>Market Research:</b> Data-driven insights into thematic and cyclical market trends</li>
          </ul>

          <br />
          <h2>The Deal Room</h2>
          <ul>
            <li><b>Rinse-&-Repeat KYC:</b> Complete KYC once to automate all future deal subscriptions</li>
            <li><b>Institutional Diligence:</b> AI-enhanced data and media rooms for transparent, rapid analysis</li>
            <li><b>Team Collaboration:</b> Dynamic profiles with sophisticated permissions for deal-specific team communication</li>
            <li><b>Presentation Ready:</b> Cloud-based UI and curated IC memos for seamless Board presentations</li>
            <li><b>Strategic Branding:</b> Programmatic access for partners to leverage our fundraising tech</li>
          </ul>
        </div>

        <div class="demo-feature-col mat-elevation-z8">
          <h2>Execution & Closing</h2>
          <ul>
            <li><b>Rapid Setup:</b> Fully onboarded in under 10 minutes. And matched to your first deal</li>
            <li><b>Dynamic Legal:</b> On-platform document negotiation, signing, and full audit trails in one place</li>
            <li><b>Structure Optimization:</b> Tailor deal structures based on specific investor preferences</li>
            <li><b>Closing Automation:</b> Fully automated document delivery, execution, and tracking</li>
            <li><b>Tokenization:</b> Future-ready infrastructure for real-asset tokenization via blockchain</li>
          </ul>

          <br />
          <h2>Portfolio Management</h2>
          <ul>
            <li><b>Command Center:</b> A comprehensive dashboard for performance, liquidity, and cash flow reporting</li>
            <li><b>Automated Tracking:</b> API-linked monitoring for K1s, financial statements, and issuer updates</li>
            <li><b>Cash Management:</b> Dynamic tracking of capital calls, distributions, and waterfalls (TVPI, DPI)</li>
            <li><b>Integrated CRM:</b> A banking-specific CRM that flows directly into client retention</li>
          </ul>
        </div>
      </div>
    </div>

    <mat-expansion-panel #tasksPanel [expanded]="true" *ngIf="tasks.length > 0" class="mt-4 mb-4 mat-elevation-z0">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h1>Pending Tasks</h1>
        </mat-panel-title>
        <mat-panel-description *ngIf="!tasksPanel.expanded">
          There are {{tasks.length}} pending task(s) that require your attention. Click on each task action button.
        </mat-panel-description>
      </mat-expansion-panel-header>

      <!-- Tasks  -->
      <div class="col-12 dashboard-container">
        <div *ngFor="let task of tasks" class="dashboard-item-card">
          <span style="display: flex; flex-direction: row; gap: 15px;">
            <span>
              <img height="50px" src="../../../../../assets/icons/pending.png" *ngIf="task.status == 'PENDING'" alt="Waiting for Rondeivu">
              <img height="50px" src="../../../../../assets/icons/task.png" *ngIf="task.status == 'TASK'" alt="Required Task">
            </span>
            <span>
              <div class="header">{{task.title}}</div>
              <div class="body">{{task.message}}</div>
            </span>
          </span>
          <span>
            <button mat-raised-button color="primary" (click)="clickItem(task)">{{task.linkText}}</button>
          </span>
        </div>
      </div>
    </mat-expansion-panel>

    <div class="col-12 dashboard-container" *ngIf="tasks.length == 0" style="gap: 2px;">
      <div class="dashboard-item-card" *ngIf="liveDeals.length > 0">
        <span style="display: flex; flex-direction: row; gap: 15px; align-items: center;">
          <img height="50px" src="../../../../../assets/icons/live-deal.png" alt="Forwarding to your live deals">
          <div class="header" *ngIf="liveDeals.length == 1">You have one live deal</div>
          <div class="header" *ngIf="liveDeals.length > 1">You have {{liveDeals.length}} live deals</div>
        </span>
        <span>
          <button mat-raised-button color="primary" (click)="viewLiveDeals()">View Live Deals Now!</button>
        </span>
      </div>

      <div class="dashboard-item-card" *ngIf="pendingDeals.length > 0">
        <span style="display: flex; flex-direction: row; gap: 15px; align-items: center;">
          <img height="50px" src="../../../../../assets/icons/pending-deal.png" alt="Forwarding to your pending deals">
          <div class="header" *ngIf="pendingDeals.length == 1">You have one deal pending review or onboarding</div>
          <div class="header" *ngIf="pendingDeals.length > 1">You have {{pendingDeals.length}} deals pending review or onboarding</div>
        </span>
        <span>
          <button mat-raised-button color="primary" (click)="viewPendingDeals()">View Pending Deals Now!</button>
        </span>
      </div>
    </div>

  </div>
</div>
